// actions.js
import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  generatePaymentVoucher: [
    'companyID',
    'documentNumber',
    'documentType',
    'internalSeries',
    'documentDate',
    'totalAmount'
  ],
  generatePaymentVoucherSuccess: ['data'],
  generatePaymentVoucherRequest: null,
  generatePaymentVoucherFailure: ['error']
});

export { Creators, Types };
